import { getBulkData } from './getBulkData'
import { getData } from './getData'
import { getDetails } from 'controller/performer/getDetails'
import { getEvents } from 'controller/performer/getEvents'
import { getMetadata } from 'controller/performer/getMetadata'
import { getSeasons } from 'controller/performer/getSeasons'
import { getActiveEvents } from './getActiveEvents'
import { getActiveTypeticketcollections } from './getActiveTypeTicketCollections'

export const PerformerController = {
  getDetails,
  getEvents,
  getSeasons,
  getMetadata,
  getData,
  getBulkData,
  getActiveEvents,
  getActiveTypeticketcollections
}
